import React from "react";
import { orderData } from "./dummyData";

export const DynamicBoxes = ({
  packVoltage,
  packCapacity,
  packWeight,
  totalCells,
  packPrice,
  isConfig,
  num_cols,
  num_row,
  cellVoltage,
  cellCapacity,
}) => {
  return (
    <div className="flex flex-row gap-6 flex-wrap items-center justify-center text-sm text-center md:text-lg lg:text-xl max-xs:flex-col max-xs:items-center">
      <div className="max-w-[300px] flex flex-col items-center border-4 border-double border-[#ff851b] p-4 max-xs:w-full">
        <span className="text-white-translucent">No. of Cells</span>
        <span className="text-[#e8442d]">
          {totalCells} ( {num_cols} x {num_row} )
        </span>
      </div>
      <div className="max-w-[300px] flex flex-col items-center border-4 border-double border-[#ff851b] p-4 max-xs:w-full">
        <span className="text-white-translucent">Pack Voltage</span>
        <span className="text-[#e8442d]"> {packVoltage} V ( {cellVoltage} V x {num_cols} )
        </span>
      </div>
      <div className="max-w-[300px] flex flex-col items-center border-4 border-double border-[#ff851b] p-4 max-xs:w-full">
        <span className="text-white-translucent">Pack Capacity</span>
        <span className="text-[#e8442d]">
          {packCapacity} AH ( {cellCapacity} Ah x {num_row} )
        </span>
      </div>
      {!isConfig && (
        <>
          <div className="max-w-[300px] flex flex-col items-center border-4 border-double border-[#ff851b] p-4 max-xs:w-full">
            <span className="text-white-translucent">Pack Weight</span>
            <span className="text-[#e8442d]">{packWeight} Kg</span>
          </div>
        </>
      )}
    </div>
  );
};
